import React, { Component } from "react";
import "./DashBoards.css";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import funnelModule from "highcharts/modules/funnel";
if (typeof funnelModule === "function") {
  funnelModule(Highcharts);
} else if (typeof funnelModule?.default === "function") {
  funnelModule.default(Highcharts);
}

const CHART_COLORS = [
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
  "#C9CBCF",
  "#7BC225",
  "#E74C3C",
  "#3498DB",
  "#2ECC71",
  "#F39C12",
  "#8E44AD",
  "#1ABC9C",
  "#D35400",
];

const CARD_THEMES = [
  {
    gradient: "linear-gradient(135deg, #4A90E2 0%, #376CAA 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #5DADE2 0%, #4682AA 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #48C9B0 0%, #369784 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #5D9CEC 0%, #4675B1 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #6C7BD9 0%, #515CA3 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #7FB3D5 0%, #5F86A0 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #52BE80 0%, #3E8F60 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #5499C7 0%, #3F7395 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #76D7C4 0%, #59A193 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #85C1E9 0%, #6491AF 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #A569BD 0%, #7C4F8E 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #45B39D 0%, #348676 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #6FB1FC 0%, #5385BD 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #5DBEAA 0%, #468F80 100%)",
    accent: "#ffffff",
  },
  {
    gradient: "linear-gradient(135deg, #7C98B3 0%, #5D7286 100%)",
    accent: "#ffffff",
  },
];

export default class ITHomeDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      isSubmitting: false,
      step: 1,
      time: new Date(),
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      loginTimes: [],
      logoutTimes: [],
      isWorking: false,
      lastActivity: null,
      dealsdata: [],
      data: [],
      data1: [],
      data2: [],
      chartData: {},
      showModal: false,
      widgets: [],
      editIndex: null,
      layouttwo: [],
      layout: [],
      drilldownLevel: 0,
      currentChartData: null,
      drillStackByWidget: {},
      drillParamsByWidget: {},
      dealuser: [],
      chartRefs: {},
      employees: [],
      tvMode: false,
      tvAuthenticated: false,
      pageConfig: null,
      pageParams: null,
      activeTab: 0,
      widgetMeta: {},
      loadingCharts: {},
      loadedTabs: {},
      tabLoading: false,
      loading: true,
      error: null,
      tabFade: true,

      // ── Filter state ──────────────────────────────────────
      fromDate: "",
      toDate: "",
      employeeId: "",
      recentActivities: [],
    };
    this.rotateTimer = null;
    this.isAutoRotating = false;
    this.rotationId = 0;
    this.tabNavRef = React.createRef();
  }

  // ─────────────────────────────────────────────────────────────────
  // Toast helper
  // ─────────────────────────────────────────────────────────────────
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  // ─────────────────────────────────────────────────────────────────
  // Lifecycle
  // ─────────────────────────────────────────────────────────────────
  componentDidMount() {
    window.addEventListener("resize", this.handleResize);

    const tvAuthDetail = this.props.tvAuthDetail;
    if (tvAuthDetail) {
      this.setState(
        {
          tvMode: true,
          tvAuthenticated: true,
          sId: tvAuthDetail.sessionId,
          uId: tvAuthDetail.employees_Id,
          tvPageRoute: tvAuthDetail.pageRoute || "ithomedashboard",
        },
        () => {
          this.fetchPageConfig();
        },
      );
    } else {
      this.fetchPageConfig();
    }
    this.employeesfetchHandler();
    this.IttaskstablefetchHandler();
    // Clock tick
    this.timerID = setInterval(() => this.setState({ time: new Date() }), 1000);
  }

  componentWillUnmount() {
    if (this.timerID) clearInterval(this.timerID);
    if (this.fetchTimeoutId) clearTimeout(this.fetchTimeoutId);
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    if (this.endCurrentSession) this.endCurrentSession();
    if (this.rotateTimer) clearTimeout(this.rotateTimer);
    window.removeEventListener("resize", this.handleResize);
  }

  // ─────────────────────────────────────────────────────────────────
  // Employees list
  // ─────────────────────────────────────────────────────────────────
  employeesfetchHandler = () => {
    fetch(configData.api_url + "C_Employees/list", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };

  IttaskstablefetchHandler = () => {
    const { sId, uId } = this.state;
    const formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);

    fetch(configData.api_url + "C_Ittaskstable/getUserTasksByUserId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const tasks = data.tasks || [];
          const now = new Date();
          const currYear = now.getFullYear();
          const currMonth = now.getMonth();
          const filtered = tasks
            .filter((t) => {
              if (String(t.stagename) !== "3") return false;
              if (!t.createdOn) return false;
              const d = new Date(t.createdOn.replace(" ", "T"));
              return d.getFullYear() === currYear && d.getMonth() === currMonth;
            })
            .sort(
              (a, b) =>
                new Date(b.createdOn.replace(" ", "T")) -
                new Date(a.createdOn.replace(" ", "T")),
            );
          this.setState({ recentActivities: filtered });
        }
      })
      .catch(() => {});
  };

  formatRelativeTime = (dateStr) => {
    if (!dateStr || dateStr.startsWith("0000-00-00")) return "—";
    const d = new Date(dateStr.replace(" ", "T") + "Z");
    if (isNaN(d.getTime())) return "—";
    const diffMs = Date.now() - d.getTime();
    if (diffMs < 0) return "0 min";
    const totalMins = Math.floor(diffMs / 60000);
    if (totalMins < 60) return `${totalMins} min`;
    const totalHours = Math.floor(totalMins / 60);
    if (totalHours < 24) return `${totalHours} hours`;
    const days = Math.floor(totalHours / 24);
    return `${days} day${days > 1 ? "s" : ""}`;
  };

  getEmployeeName = (employees_Id) => {
    const emp = (this.state.employees || []).find(
      (e) => String(e.employees_Id) === String(employees_Id),
    );
    return emp ? `${emp.fName || ""} ${emp.lName || ""}`.trim() : "—";
  };
  handleResize = () => {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => this.forceUpdate(), 200);
  };

  // ─────────────────────────────────────────────────────────────────
  // Filter handlers  ← NEW
  // ─────────────────────────────────────────────────────────────────
  handlepipelineIdChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleemployeeIdChange = (e) => {
    this.setState({ employeeId: e.target.value });
  };

  // ─────────────────────────────────────────────────────────────────
  // Fetch button handler  ← NEW
  // ─────────────────────────────────────────────────────────────────
  PipelinesupdateHandler = () => {
    const { fromDate, toDate, employeeId, pageParams, activeTab } = this.state;

    if (!pageParams || !pageParams.tabs) return;
    const tab = pageParams.tabs[activeTab];
    if (!tab || !tab.widgetIds || tab.widgetIds.length === 0) return;

    this.setState({ tabLoading: true }, () => {
      const fetchPromises = tab.widgetIds.map((widgetId) =>
        this.fetchWidgetDataWithFilters(activeTab, widgetId, tab.params || {}, {
          fromDate,
          toDate,
          employeeId,
        }),
      );

      Promise.all(fetchPromises)
        .then((results) => {
          const nextChartData = { ...this.state.chartData };
          const nextWidgetMeta = { ...this.state.widgetMeta };

          results.forEach((result) => {
            if (!result) return;
            nextChartData[result.chartKey] = result.chartData;
            nextWidgetMeta[result.chartKey] = result.meta;
          });

          this.setState({
            chartData: nextChartData,
            widgetMeta: nextWidgetMeta,
            tabLoading: false,
          });
        })
        .catch(() => {
          this.setState({ tabLoading: false });
        });
    });
  };

  // ─────────────────────────────────────────────────────────────────
  // Fetch with filters  ← NEW
  // ─────────────────────────────────────────────────────────────────
  fetchWidgetDataWithFilters = (
    tabIndex,
    widgetId,
    tabParams,
    filters = {},
  ) => {
    const chartKey = `tab_${tabIndex}_widget_${widgetId}`;

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetId", widgetId);
    formData.append("skipTeamFilter", "yes");

    // Append tab-level params
    if (tabParams && typeof tabParams === "object") {
      Object.entries(tabParams).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    // ── Append filter values (only if not empty) ────────────────
    // NOTE: "fromDate" / "toDate" are reserved by the backend controller.
    // Replace the keys below with the actual column names used in your
    // widgetdefinition table (e.g. "createdOn__gte" / "createdOn__lte").
    // See Section 12 of the Runtime Filters manual for the reserved list.
    if (filters.fromDate) formData.append("createdOn__gte", filters.fromDate);
    if (filters.toDate) formData.append("createdOn__lte", filters.toDate);
    formData.append("dealOwner", filters.employeeId || this.state.uId);
    // ─────────────────────────────────────────────────────────────

    return fetch(
      configData.api_url + "C_Widgetdefinition/getWidgetDataDrilldown1",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        const meta = data.widgetMeta || data.widget_meta || data.meta || {};
        console.log("Widget API response for widgetId", widgetId, ":", data);
        return {
          chartKey,
          chartData: Array.isArray(data.chart_data) ? data.chart_data : [],
          meta,
        };
      })
      .catch(() => ({ chartKey, chartData: [], meta: {} }));
  };

  // ─────────────────────────────────────────────────────────────────
  // Page config
  // ─────────────────────────────────────────────────────────────────
  fetchPageConfig = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("pageRoute", this.state.tvPageRoute || "ithomedashboard");

    fetch(configData.api_url + "C_Widget_framework/get_page_config", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.pageConfig) {
          const pageParams = data.pageConfig.pageParams || {};
          const allTabs = Array.isArray(pageParams.tabs) ? pageParams.tabs : [];
          const myUid = String(this.state.uId);
          const myTab = allTabs.find(
            (t) => t && t.params && String(t.params.assignedTo) === myUid,
          );
          const filteredTabs = myTab ? [myTab] : [];
          const scopedPageParams = {
            ...pageParams,
            tabs: filteredTabs,
            autoRotate: false,
          };

          if (filteredTabs.length === 0) {
            this.setState({
              pageConfig: data.pageConfig,
              pageParams: scopedPageParams,
              activeTab: 0,
              loading: false,
              error:
                "No dashboard configured for the logged-in user. Please contact admin.",
            });
            return;
          }

          this.setState(
            {
              pageConfig: data.pageConfig,
              pageParams: scopedPageParams,
              activeTab: 0,
              loading: false,
            },
            () => {
              this.loadTabCharts(0);
            },
          );
        } else {
          this.setState({
            loading: false,
            error:
              "Page config not found. Please create a page_layouts entry for 'ithomedashboard'.",
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false, error: "Failed to load page config." });
      });
  };

  // ─────────────────────────────────────────────────────────────────
  // Auto-rotation
  // ─────────────────────────────────────────────────────────────────
  startAutoRotation = (pageParams) => {
    if (
      pageParams.autoRotate &&
      pageParams.tabs &&
      pageParams.tabs.length > 1
    ) {
      this.rotationId++;
      if (this.rotateTimer) clearTimeout(this.rotateTimer);
      const interval = (pageParams.rotateInterval || 30) * 1000;
      this.scheduleNextRotation(pageParams, interval, this.rotationId);
    }
  };

  scheduleNextRotation = (pageParams, interval, myRotationId) => {
    this.rotateTimer = setTimeout(() => {
      if (myRotationId !== this.rotationId) return;
      this.isAutoRotating = true;
      const nextTab = (this.state.activeTab + 1) % pageParams.tabs.length;
      this.switchTabWithFade(nextTab, () => {
        this.isAutoRotating = false;
        if (myRotationId !== this.rotationId) return;
        this.scheduleNextRotation(pageParams, interval, myRotationId);
      });
    }, interval);
  };

  // ─────────────────────────────────────────────────────────────────
  // Tab data loading
  // ─────────────────────────────────────────────────────────────────
  loadTabCharts = (tabIndex) => {
    const { pageParams, loadedTabs } = this.state;
    if (!pageParams || !pageParams.tabs) return Promise.resolve();
    if (loadedTabs[tabIndex]) return Promise.resolve();

    const tab = pageParams.tabs[tabIndex];
    if (!tab || !tab.widgetIds || tab.widgetIds.length === 0)
      return Promise.resolve();

    this.setState((prevState) => ({
      loadedTabs: { ...prevState.loadedTabs, [tabIndex]: true },
      tabLoading: true,
    }));

    const fetchPromises = tab.widgetIds.map((widgetId) =>
      this.fetchWidgetData(tabIndex, widgetId, tab.params || {}),
    );
    return Promise.all(fetchPromises)
      .then((results) => {
        const nextChartData = { ...this.state.chartData };
        const nextWidgetMeta = { ...this.state.widgetMeta };

        results.forEach((result) => {
          if (!result) return;
          nextChartData[result.chartKey] = result.chartData;
          nextWidgetMeta[result.chartKey] = result.meta;
        });

        this.setState({
          chartData: nextChartData,
          widgetMeta: nextWidgetMeta,
          tabLoading: false,
        });
      })
      .catch(() => {
        this.setState({ tabLoading: false });
      });
  };

  fetchWidgetData = (tabIndex, widgetId, tabParams) => {
    const chartKey = `tab_${tabIndex}_widget_${widgetId}`;

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetId", widgetId);
    formData.append("skipTeamFilter", "yes");
    formData.append("dealOwner", this.state.uId);

    const CREATED_BY_WIDGETS = [463, 458, 459, 460, 461];
    if (CREATED_BY_WIDGETS.includes(Number(widgetId))) {
      formData.append("createdBy", this.state.uId);
      formData.append("updatedBy", this.state.uId);
    }

    // These widgets show only the last 7 days (today + past 6 days)
    const LAST_7_DAYS_WIDGETS = [448, 449];
    if (LAST_7_DAYS_WIDGETS.includes(Number(widgetId))) {
      const fmt = (d) =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate(),
        ).padStart(2, "0")}`;
      const today = new Date();
      const past = new Date();
      past.setDate(today.getDate() - 6); // 6 days back + today = 7 days
      formData.append("taskDoneDate__gte", fmt(past));
      formData.append("taskDoneDate__lte", fmt(today));
    }

    if (tabParams && typeof tabParams === "object") {
      Object.entries(tabParams).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    return fetch(
      configData.api_url + "C_Widgetdefinition/getWidgetDataDrilldown1",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        const meta = data.widgetMeta || data.widget_meta || data.meta || {};
        console.log("Widget API response for widgetId", widgetId, ":", data);
        return {
          chartKey,
          chartData: Array.isArray(data.chart_data) ? data.chart_data : [],
          meta,
        };
      })
      .catch(() => ({ chartKey, chartData: [], meta: {} }));
  };

  // ─────────────────────────────────────────────────────────────────
  // Chart helpers
  // ─────────────────────────────────────────────────────────────────
  mapChartType = (dbChartType) => {
    if (!dbChartType) return { type: "column", isPie: false };
    const upper = dbChartType.toUpperCase();
    const mapping = {
      BAR: { type: "column", isPie: false },
      COLUMN: { type: "column", isPie: false },
      LINE: { type: "line", isPie: false },
      AREA: { type: "area", isPie: false },
      PIE: { type: "pie", isPie: true, innerSize: "0%" },
      DONUT: { type: "pie", isPie: true, innerSize: "50%" },
      DOUGHNUT: { type: "pie", isPie: true, innerSize: "50%" },
      FUNNEL: { type: "funnel", isPie: false },
      SCATTER: { type: "scatter", isPie: false },
    };
    return mapping[upper] || { type: "column", isPie: false };
  };

  getChartHeight = () => {
    const w = window.innerWidth;
    if (w >= 1400) return 360;
    if (w >= 1200) return 320;
    if (w >= 992) return 290;
    if (w >= 768) return 260;
    return 240;
  };

  _chartOptionsCache = {};

  buildChartOptions = (chartDataArr, chartKey) => {
    if (!chartDataArr || chartDataArr.length === 0) return null;

    const meta = this.state.widgetMeta[chartKey] || {};

    // Return cached options if data & meta references haven't changed.
    // Prevents Highcharts re-render on unrelated state updates (clock tick, etc.)
    const cached = this._chartOptionsCache[chartKey];
    if (cached && cached.data === chartDataArr && cached.meta === meta) {
      return cached.options;
    }

    const chartInfo = this.mapChartType(meta.chartType);
    const isFunnel = chartInfo.type === "funnel";
    // Line-type charts need ONE solid line colour (colorByPoint leaves the line grey)
    const isLineType = [
      "line",
      "spline",
      "area",
      "areaspline",
      "scatter",
    ].includes(chartInfo.type);
    const lineColor = "#1282ce";
    // TV mode: bigger/bolder so it's clear from a distance
    const tv = this.state.tvMode;
    const labelFont = tv ? "20px" : "12px";
    const axisFont = tv ? "16px" : "11px";
    const tvLineWidth = tv ? 4 : 2;
    const tvMarkerRadius = tv ? 8 : 4;

    const cleanedData = isFunnel
      ? chartDataArr.filter(
          (item) =>
            item && item.y && item.y > 0 && item.name && item.name.trim(),
        )
      : chartDataArr;

    const labels = cleanedData.map((item) => item.name || "");
    // The backend SUMs MySQL TIME columns, which produces an HHMMSS-encoded
    // integer (e.g. "08:00:00" -> 80000) instead of real hours. For widgets
    // whose name mentions hours, decode that number back into decimal hours.
    // NOTE: exact only when each day/group has a single row; multi-row groups
    // can drift. Permanent fix is SUM(TIME_TO_SEC(col))/3600 in the backend.
    const isHoursWidget = /hour|hrs/i.test(meta.widgetName || "");
    const decodeHours = (n) => {
      const num = Math.round(Number(n) || 0);
      const hh = Math.floor(num / 10000);
      const mm = Math.floor((num % 10000) / 100);
      const ss = num % 100;
      return Math.round((hh + mm / 60 + ss / 3600) * 100) / 100;
    };
    const values = cleanedData.map((item) =>
      isHoursWidget ? decodeHours(item.y) : item.y || 0,
    );
    const colors = labels.map((_, i) => CHART_COLORS[i % CHART_COLORS.length]);

    // Multi-series split: backend may tag rows with `series` (the dummyone /
    // "Series Column", e.g. assignedTo) so a date has one row per member. Build
    // ONE Highcharts series per value with UNIQUE categories. Without this the
    // rows collapse into a single series of duplicate-named points, which crashes
    // Highcharts ("Cannot set properties of null (setting 'requireSorting')").
    const hasSeriesSplit =
      Array.isArray(chartDataArr) &&
      chartDataArr.some(
        (d) =>
          d && d.series !== undefined && d.series !== null && d.series !== "",
      );
    if (hasSeriesSplit && !chartInfo.isPie) {
      const cats = [];
      chartDataArr.forEach((d) => {
        const n = d.name || "";
        if (!cats.includes(n)) cats.push(n);
      });
      const groups = {};
      chartDataArr.forEach((d) => {
        const s = String(d.series);
        if (!groups[s]) groups[s] = {};
        groups[s][d.name || ""] = isHoursWidget ? decodeHours(d.y) : d.y || 0;
      });
      const splitStacking = isLineType ? undefined : "normal";
      const splitSeries = Object.keys(groups).map((s, i) => ({
        name: s,
        data: cats.map((c) => (groups[s][c] !== undefined ? groups[s][c] : 0)),
        color: CHART_COLORS[i % CHART_COLORS.length],
      }));
      const splitOptions = {
        chart: { type: chartInfo.type, height: this.getChartHeight() },
        title: { text: null },
        credits: { enabled: false },
        legend: { enabled: true, itemStyle: { fontSize: axisFont } },
        plotOptions: {
          series: {
            stacking: splitStacking,
            ...(isLineType
              ? {
                  lineWidth: tvLineWidth,
                  marker: { enabled: true, radius: tvMarkerRadius },
                }
              : {}),
            dataLabels: {
              enabled: true,
              crop: false,
              overflow: "allow",
              ...(isLineType
                ? {}
                : { inside: true, verticalAlign: "middle", align: "center" }),
              style: {
                fontWeight: "bold",
                fontSize: labelFont,
                color: isLineType ? lineColor : "#ffffff",
                textOutline: isLineType ? "2px #ffffff" : "1px contrast",
              },
              formatter: function () {
                if (!this.y) return null;
                return isHoursWidget ? this.y + " h" : this.y;
              },
            },
          },
        },
        xAxis: {
          categories: cats,
          title: { text: null },
          labels: {
            style: { fontSize: axisFont, fontWeight: tv ? "bold" : "normal" },
          },
        },
        yAxis: {
          title: {
            text: isHoursWidget ? "Hours" : "Count",
            style: { fontSize: axisFont },
          },
          labels: { style: { fontSize: axisFont } },
        },
        tooltip: { pointFormat: "<b>{series.name}</b>: {point.y}" },
        series: splitSeries,
      };
      this._chartOptionsCache[chartKey] = {
        data: chartDataArr,
        meta,
        options: splitOptions,
      };
      return splitOptions;
    }

    const seriesData = labels.map((label, index) => ({
      name: label,
      y: values[index],
      color: colors[index],
    }));

    if (isFunnel) {
      const options = {
        chart: {
          type: "funnel",
          height: this.getChartHeight(),
          backgroundColor: "transparent",
        },
        title: { text: null },
        credits: { enabled: false },
        legend: { enabled: false },
        plotOptions: {
          series: {
            colorByPoint: true,
            center: ["40%", "50%"],
            neckWidth: "20%",
            neckHeight: "28%",
            width: "70%",
            height: "90%",
            borderWidth: 1,
            borderColor: "#ffffff",
            dataLabels: {
              enabled: true,
              softConnector: true,
              distance: 20,
              padding: 3,
              crop: false,
              overflow: "allow",
              allowOverlap: false,
              connectorWidth: 1,
              connectorColor: "#bbb",
              style: {
                fontSize: "11px",
                fontWeight: "500",
                color: "#2d2d2d",
                textOutline: "none",
              },
              formatter: function () {
                const name = this.point.name || "Unknown";
                const value = (this.point.y || 0).toLocaleString();
                return "<b>" + name + "</b>: " + value;
              },
            },
          },
        },
        tooltip: {
          backgroundColor: "rgba(255,255,255,0.95)",
          borderColor: "#1282ce",
          borderRadius: 6,
          shadow: true,
          pointFormatter: function () {
            return (
              "<b>" +
              (this.name || "Unknown") +
              "</b>: " +
              (this.y || 0).toLocaleString()
            );
          },
        },
        series: [{ name: meta.widgetName || "Count", data: seriesData }],
      };
      this._chartOptionsCache[chartKey] = { data: chartDataArr, meta, options };
      return options;
    }

    const options = {
      chart: { type: chartInfo.type, height: this.getChartHeight() },
      title: { text: null },
      credits: { enabled: false },
      legend: { enabled: chartInfo.isPie },
      plotOptions: {
        series: {
          colorByPoint: !isLineType,
          ...(isLineType
            ? {
                color: lineColor,
                lineWidth: tvLineWidth,
                marker: { enabled: true, radius: tvMarkerRadius },
              }
            : {}),
          dataLabels: isLineType
            ? {
                enabled: true,
                crop: false,
                overflow: "allow",
                style: {
                  fontWeight: "bold",
                  fontSize: labelFont,
                  color: lineColor,
                  textOutline: "2px #ffffff",
                },
                formatter: function () {
                  return isHoursWidget ? this.y + " h" : this.y;
                },
              }
            : {
                enabled: true,
                inside: true,
                verticalAlign: "middle",
                align: "center",
                crop: false,
                overflow: "allow",
                style: {
                  fontWeight: "bold",
                  fontSize: labelFont,
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
                formatter: function () {
                  return isHoursWidget ? this.y + " h" : this.y;
                },
              },
        },
        pie: {
          innerSize: chartInfo.innerSize || "0%",
          dataLabels: { enabled: true, format: "{point.name}: {point.y}" },
        },
      },
      series: [{ name: meta.widgetName || "Count", data: seriesData }],
    };

    if (!chartInfo.isPie) {
      options.xAxis = {
        categories: labels,
        title: { text: null },
        labels: {
          style: { fontSize: axisFont, fontWeight: tv ? "bold" : "normal" },
        },
      };
      options.yAxis = {
        title: {
          text: isHoursWidget ? "Hours" : "Count",
          style: { fontSize: axisFont },
        },
        labels: { style: { fontSize: axisFont } },
      };
    }

    this._chartOptionsCache[chartKey] = { data: chartDataArr, meta, options };
    return options;
  };

  // ─────────────────────────────────────────────────────────────────
  // Tab switching
  // ─────────────────────────────────────────────────────────────────
  switchTabWithFade = (idx, callback) => {
    this.setState({ tabFade: false }, () => {
      setTimeout(() => {
        this.setState({ activeTab: idx, tabFade: true }, () => {
          this.loadTabCharts(idx);
          this.scrollActiveTabIntoView();
          if (callback) callback();
        });
      }, 300);
    });
  };

  handleTabSelect = (tabIndex) => {
    const idx = parseInt(tabIndex);
    if (idx === this.state.activeTab || this.isAutoRotating) return;
    this.switchTabWithFade(idx);
    if (this.rotateTimer) {
      clearTimeout(this.rotateTimer);
      this.startAutoRotation(this.state.pageParams);
    }
  };

  // ─────────────────────────────────────────────────────────────────
  // Render helpers
  // ─────────────────────────────────────────────────────────────────
  renderCardWidget = (chartDataArr, meta, theme = CARD_THEMES[0], widgetId) => {
    const showHrs = widgetId === 456 || widgetId === 436;
    return (
      <div className="d-flex flex-wrap justify-content-around align-items-center px-2 py-2">
        {chartDataArr.map((item, i) => {
          const rawValue = item.y !== undefined ? item.y : item.value;
          const numValue = parseFloat(rawValue);
          const isNumber = !isNaN(numValue);
          const trend = isNumber
            ? numValue > 0
              ? "up"
              : numValue < 0
                ? "down"
                : "flat"
            : "flat";
          const trendLabel =
            trend === "up" ? "Up" : trend === "down" ? "Down" : "Flat";
          const trendIcon =
            trend === "up"
              ? "fa-arrow-up"
              : trend === "down"
                ? "fa-arrow-down"
                : "fa-minus";
          const trendBg =
            trend === "up"
              ? "rgba(46,204,113,0.95)"
              : trend === "down"
                ? "rgba(231,76,60,0.95)"
                : "rgba(255,255,255,0.25)";
          const displayValue = isNumber
            ? showHrs
              ? (Math.abs(numValue) / 3600).toLocaleString(undefined, {
                  maximumFractionDigits: 1,
                }) + " hrs"
              : Math.abs(numValue).toLocaleString()
            : rawValue;

          return (
            <div key={i} className="text-center px-2 py-1">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ gap: "8px" }}
              >
                <span
                  className="fw-bold"
                  style={{
                    fontSize: "1.7rem",
                    color: theme.accent,
                    lineHeight: 1.1,
                  }}
                >
                  {displayValue}
                </span>
                <span
                  className="d-flex align-items-center"
                  style={{
                    background: trendBg,
                    color: "#fff",
                    padding: "2px 8px",
                    borderRadius: "20px",
                    fontSize: "0.65rem",
                    fontWeight: 700,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className={`fa ${trendIcon} me-1`}
                    style={{ fontSize: "0.6rem" }}
                  />
                  {trendLabel}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  renderChart = (tabIndex, widgetId, theme) => {
    const chartKey = `tab_${tabIndex}_widget_${widgetId}`;
    const isLoading = this.state.loadingCharts[chartKey];
    const chartDataArr = this.state.chartData[chartKey];
    const meta = this.state.widgetMeta[chartKey] || {};

    if (isLoading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "200px" }}
        >
          <Spinner animation="border" variant="primary" size="sm" />
          <span className="ms-2 text-muted">Loading chart...</span>
        </div>
      );
    }

    const isEmptyData =
      !chartDataArr ||
      chartDataArr.length === 0 ||
      chartDataArr.every(
        (item) =>
          (item.name === null || item.name === undefined || item.name === "") &&
          (parseFloat(item.y !== undefined ? item.y : item.value) || 0) === 0,
      );
    if (isEmptyData) {
      const isCard = meta.chartType && meta.chartType.toUpperCase() === "CARD";
      return (
        <div
          className="d-flex justify-content-center align-items-center text-muted"
          style={{
            minHeight: isCard ? "60px" : "200px",
            fontSize: isCard ? "0.85rem" : "1rem",
          }}
        >
          No data available
        </div>
      );
    }

    if (meta.chartType && meta.chartType.toUpperCase() === "CARD") {
      return this.renderCardWidget(chartDataArr, meta, theme, widgetId);
    }

    const options = this.buildChartOptions(chartDataArr, chartKey);
    if (!options) return null;

    return (
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        key={chartKey}
      />
    );
  };

  scrollActiveTabIntoView = () => {
    if (this.tabNavRef.current) {
      const activeBtn = this.tabNavRef.current.children[this.state.activeTab];
      if (activeBtn) {
        activeBtn.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  };

  scrollTabs = (direction) => {
    if (this.tabNavRef.current) {
      this.tabNavRef.current.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth",
      });
    }
  };

  renderTabs = () => {
    const { pageParams, activeTab, tabLoading } = this.state;

    if (!pageParams || !pageParams.tabs || pageParams.tabs.length === 0) {
      return (
        <div className="text-muted p-3">
          No tabs configured. Add pageParams JSON to the page_layouts entry.
        </div>
      );
    }

    const activeTabData = pageParams.tabs[activeTab];

    if (tabLoading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "320px" }}
        >
          <Spinner animation="border" variant="primary" />
          <span className="ms-2 text-muted">Loading charts...</span>
        </div>
      );
    }

    const widgetIds = activeTabData.widgetIds || [];
    const cardWidgetIds = [];
    const chartWidgetIds = [];
    widgetIds.forEach((widgetId) => {
      const meta =
        this.state.widgetMeta[`tab_${activeTab}_widget_${widgetId}`] || {};
      if ((meta.chartType || "").toUpperCase() === "CARD") {
        cardWidgetIds.push(widgetId);
      } else {
        chartWidgetIds.push(widgetId);
      }
    });

    return (
      <div
        style={{
          opacity: this.state.tabFade ? 1 : 0,
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        {/* Row 1 — CARD widgets, 4 per row, themed */}
        {cardWidgetIds.length > 0 && (
          <Row className="g-3 mb-3 px-2">
            {cardWidgetIds.map((widgetId, wIndex) => {
              const theme = CARD_THEMES[wIndex % CARD_THEMES.length];
              const widgetName =
                (
                  this.state.widgetMeta[
                    `tab_${activeTab}_widget_${widgetId}`
                  ] || {}
                ).widgetName || `Widget #${widgetId}`;
              return (
                <Col xs={12} sm={6} md={4} lg={3} key={wIndex}>
                  <Card
                    className="h-100 border-0 themed-card"
                    style={{
                      background: theme.gradient,
                      borderRadius: "12px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Card.Body className="p-3">
                      <Card.Title
                        className="fs-6 m-0 ms-1 mb-1"
                        style={{
                          color: theme.accent,
                          fontWeight: "700",
                          fontSize: "0.85rem",
                        }}
                      >
                        {widgetName}
                      </Card.Title>
                      {this.renderChart(activeTab, widgetId, theme)}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}

        {/* Row 2 — Chart widgets, 3 per row */}
        {chartWidgetIds.length > 0 && (
          <Row
            className="pt-3 px-2 border border-primary border-3 rounded-2 m-0"
            style={{
              backgroundColor: "#e1f3ff",
              overflow: "hidden",
            }}
          >
            {chartWidgetIds.map((widgetId, wIndex) => (
              <Col md={6} lg={4} key={wIndex} className="mb-3">
                <Card className="border-2 h-100">
                  <Card.Body className="p-1">
                    <Card.Title className="fs-6 m-0 ms-2">
                      {(
                        this.state.widgetMeta[
                          `tab_${activeTab}_widget_${widgetId}`
                        ] || {}
                      ).widgetName || `Widget #${widgetId}`}
                    </Card.Title>
                    {this.renderChart(activeTab, widgetId)}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    );
  };

  getGreeting() {
    const hour = this.state.time.getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  }
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.dealsdata.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  // ─────────────────────────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────────────────────────
  render() {
    const { loading, error, tvMode } = this.state;
    const greeting = this.getGreeting();
    const uName = sessionStorage.getItem("userName");
    const currentTime = this.state.time.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    if (loading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          {this.state.isSubmitting && (
            <div className="submit-loader-overlay">
              <div className="loader-content">
                <div className="app-loader">Loading...</div>
              </div>
              <div className="loader-text">Processing your request...</div>
            </div>
          )}

          <Spinner animation="border" variant="primary" />
        </div>
      );
    }

    if (error) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          <div className="text-center text-danger">
            <h5>Error</h5>
            <p>{error}</p>
          </div>
        </div>
      );
    }
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.dealsdata.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );
    return (
      <div>
        {/* ── Greeting card ─────────────────────────────────────── */}
        <Row className="mb-4">
          <Col md={12}>
            <Card className="p-3">
              <Row className="align-items-center">
                <Col lg="9" md="9">
                  <h2>
                    {greeting}, {uName}!
                  </h2>
                  <p className="mb-0">Your performance is looking good!</p>
                </Col>
                <Col>
                  <p className="mb-0">Current time: {currentTime}</p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        {/* ── Filter bar ──────────────────────────────────────────
        <Row className="mb-4">
          <Col>
            <Card>
              <Card.Body>
                <Row className="align-items-end g-2">
                  <Col lg="4" md="5" sm="6">
                    <Form.Label className="mb-1" style={{ fontSize: "0.85rem" }}>
                      Sales Person
                    </Form.Label>
                    <Form.Select
                      size="sm"
                      onChange={this.handleemployeeIdChange}
                      name="employeeId"
                      value={this.state.employeeId}
                    >
                      <option value="">Select</option>
                      {this.state.employees
                        .filter(
                          (api) =>
                            api.dName && api.dName.toUpperCase() === "SALES",
                        )
                        .map((api, index) => (
                          <option key={index} value={api.employees_Id}>
                            {api.fName}&nbsp;{api.lName}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                  <Col xs="auto" className="d-flex align-items-end">
                    <Button
                      size="sm"
                      variant="success"
                      onClick={this.PipelinesupdateHandler}
                      style={{ minWidth: "100px" }}
                    >
                      Fetch
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}

        {/* ── Chart area ────────────────────────────────────────── */}
        {tvMode ? (
          <div
            className="p-0"
            style={{
              height: "100vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="container-fluid"
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="row" style={{ flex: 1, overflow: "hidden" }}>
                <div
                  className="col-md-12 col-sm-12 col-xs-12"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="x_panel"
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="x_content"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                      }}
                    >
                      <div className="text-center mb-2">
                        <span
                          className="mb-0 fs-4"
                          style={{ color: "#1282ce", fontWeight: "bold" }}
                        >
                          IT Homepage
                        </span>
                      </div>
                      {this.renderTabs()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="pb-5">
            <div className="text-center mb-3">
              <span
                className="fs-4"
                style={{ color: "#1282ce", fontWeight: "bold" }}
              >
                IT Homepage
              </span>
            </div>
            {this.renderTabs()}

            {/* ── Recent Activity ──────────────────────────── */}
            <Row className="mt-4 px-2">
              <Col>
                <Card>
                  <Card.Body>
                    <Card.Title
                      className="fs-6 mb-3"
                      style={{ color: "#1282ce", fontWeight: "bold" }}
                    >
                      <i className="fa fa-clock me-2" />
                      Recent Activity
                    </Card.Title>
                    <div className="table-responsive">
                      <table className="table table-striped table-hover mb-0">
                        <thead>
                          <tr>
                            <th>Event</th>
                            <th>Module</th>
                            <th>User</th>
                            <th>Time</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.recentActivities.length === 0 ? (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center text-muted py-3"
                              >
                                No activity for current month
                              </td>
                            </tr>
                          ) : (
                            this.state.recentActivities.map((task, idx) => (
                              <tr key={task.ittaskstable_Id || idx}>
                                <td>{task.taskName || "—"}</td>
                                <td>{task.projectName || "—"}</td>
                                <td>{this.getEmployeeName(task.assignedTo)}</td>
                                <td>
                                  {this.formatRelativeTime(task.createdOn)}
                                </td>
                                <td>
                                  <span
                                    className="badge"
                                    style={{
                                      background: "rgba(46,204,113,0.95)",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "12px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Doing
                                  </span>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
